export const CommitteeEnum = {
  COMMITTEE_LIST: '/committee-list',
  COMMITTEE_PARTICIPANTS: 'committee-list/{id}/participant-list/',
  COMMITTEE_ID_PARTICIPANTS_BY_ID:
    'committee-list/{id}/participant-list/{participantId}',
  COMMITTEE_PARTICIPANTS_BY_ID: 'committee-list/participant-list/{id}',
  COMMITTEE_ID: '/committee-list/{id}',
  VERIFY_INCONSISTENCIES: '/committee-list/{committeeId}/inconsistencies',
  VERIFY_INCONSISTENCIES_STEP_WITH_DETAILS:
    '/committee-list/{committeeId}/inconsistencies?withDetails=true&courseVersionId={courseVersionId}',
  COMMITTEE_LIST_BY_TECH_AREA_VERSION: '/committee-list/area-version/{id}',
  COURSE_LIST_BY_COMMITTEE: '/committee-list/{id}/course-list',
  DEPARTMENT_LIST: 'committee-list/department-list',
  COURSE_VERSION: {
    READ_OR_UPDATE_COURSE_VERSION_MODALITY_LEVEL_LIST:
      '/committee-list/course-version/{courseVersionId}/modality-level-list',
    READ_OR_UPDATE_COURSE_VERSION_MODALITY_LEVEL_LIST_AVAILABLE:
      '/committee-list/course-version/{courseVersionId}/modality-level-list/available',

    COURSE_NAME: '/committee-list/course-version/{courseVersionId}/course-name',

    ACCESS_REQUIREMENT_LIST:
      '/committee-list/course-version/{courseVersionId}/access-requirement-list',
    ACCESS_REQUIREMENT_DELETE:
      '/committee-list/course-version/{courseVersionId}/access-requirement-cv-list/{accessRequirementId}',
    ACCESS_REQUIREMENTS_AVAILABLE:
      '/committee-list/course-version/{courseVersionId}/access-requirement-list/available',
    ACCESS_REQUIREMENTS_CREATE_BY_COURSE_VERSION:
      '/committee-list/course-version/{courseVersionId}/access-requirement-cv-list',

    PRODUCTION_MEAN_LIST:
      '/committee-list/course-version/{courseVersionId}/production-mean-list',
    PRODUCTION_MEAN_DELETE:
      '/committee-list/course-version/{courseVersionId}/production-mean-cv-list/{productionMeanId}',
    PRODUCTION_MEANS_AVAILABLE:
      '/committee-list/course-version/{courseVersionId}/production-mean-list/available',
    PRODUCTION_MEANS_CREATE_BY_COURSE_VERSION:
      '/committee-list/course-version/{courseVersionId}/production-mean-cv-list',

    WORK_CONDITION_LIST:
      '/committee-list/course-version/{courseVersionId}/work-condition-list',
    WORK_CONDITION_DELETE:
      '/committee-list/course-version/{courseVersionId}/work-condition-cv-list/{workConditionId}',
    WORK_CONDITIONS_AVAILABLE:
      '/committee-list/course-version/{courseVersionId}/work-condition-list/available',
    WORK_CONDITIONS_CREATE_BY_COURSE_VERSION:
      '/committee-list/course-version/{courseVersionId}/work-condition-cv-list',

    EVOLUTION_LIST:
      '/committee-list/course-version/{courseVersionId}/evolution-list',
    EVOLUTION_DELETE:
      '/committee-list/course-version/{courseVersionId}/evolution-cv-list/{evolutionId}',
    EVOLUTIONS_AVAILABLE:
      '/committee-list/course-version/{courseVersionId}/evolution-list/available',
    EVOLUTIONS_CREATE_BY_COURSE_VERSION:
      '/committee-list/course-version/{courseVersionId}/evolution-cv-list',

    RELATED_TRAININGS_LIST:
      '/committee-list/course-version/{courseVersionId}/professional-formation-list',
    RELATED_TRAININGS_DELETE:
      '/committee-list/course-version/{courseVersionId}/professional-formation-list/{professionalFormationId}',
    RELATED_TRAININGS_MODALITY_LIST:
      '/committee-list/course-version/{courseVersionId}/modality-list',
    RELATED_TRAININGS_AREA_LIST:
      '/committee-list/course-version/{courseVersionId}/area-version',
    RELATED_TRAININGS_COURSE_LIST:
      '/committee-list/course-version/{courseVersionId}/area-version/{areaVersionId}/modality-list/{modalityId}',

    CBO_FAMILY:
      'committee-list/course-version/{courseVersionId}/cbo-family-list',
    CBO_SPECIFIC:
      'committee-list/course-version/{courseVersionId}/cbo-specific-list',
    SEARCH_CBO_FAMILY:
      'committee-list/course-version/{courseVersionId}/cbo-family-list-by-code',
    INTERMEDIATE_EXITS:
      'course-version/{courseVersionId}/intermediate-exit-list',
    INTERMEDIATE_EXITS_BY_COURSE_VERSION:
      '/committee-list/course-version/{courseVersionId}/intermediate-exit-list',
  },
  COURSES_BY_COMMITTEE_ID_AND_TECH_AREA_VERSION_ID:
    '/committee-list/{committeeId}/area-version/{areaVersionId}/course-version-list',
  COURSES_BY_TYPE_AND_COMMITTEE_ID:
    '/committee-list/{committeeId}/area-version/course-version-list',
  SAVE_COMMITTEE_COURSES:
    '/committee-list/{committeeId}/course-version-list',
  SEARCH_COURSES_BY_NAME: '/committee-list/{committeeId}/course-list/search',
  ROLES_LIST: 'committee-list/role-list/',
  ROLES_LIST_BY_PARTICIPANT_ID:
    'committee-list/participant-list/{id}/role-list',
  INTERMEDIATE_EXITS_BY_COMMITTEE_ID:
    'committee-list/{committeeId}/course-list/search/intermediate-exit-list',
  DELETE_INTERMEDIATE_EXIT:
    'committee-list/intermediate-exit-list/{intermediateExitId}',
  DELETE_FUNCTION_FROM_INTERMEDIATE_EXIT:
    '/committee-list/intermediate-exit-list/{intermediateExitId}/function-list/{functionCourseVersionId}',
  INTERMEDIATE_EXIT_FUNCTIONS_LIST:
    'intermediate-exit-list/{intermediateExitId}/function-list',
  COMMITTEE_INTERMEDIATE_EXIT:
    'committee-list/intermediate-exit-list/{intermediateExitId}',
  COMMITTEE_INTERMEDIATE_EXIT_FUNCTIONS_LIST:
    'committee-list/intermediate-exit-list/{intermediateExitId}/function-list',
  INTERMEDIATE_EXIT_AVAILABLE_FUNCTIONS_LIST:
    'committee-list/intermediate-exit-list/{intermediateExitId}/function-list/available',
} as const
